import React from "react";
import { LegalPage } from "./LegalPage";
import { TERMS } from "../data/legalContent";

export default function AGB() {
  return <LegalPage data={TERMS} path="/agb" testId="agb-page" />;
}
